import { useEffect } from 'react';

/**
 * While the list is open, keeps Escape from also dismissing a Dialog or Sheet around the field.
 */
export function useClaimEscapeWhileOpen(isOpen: boolean) {
  useEffect(() => {
    if (!isOpen) return;

    // Radix dialogs listen on `document` in the capture phase and dismiss unless the event is
    // already default-prevented. Base UI's popup is not a Radix layer, so the dialog takes itself
    // for the topmost one and closes with the list. A capture listener on `window` runs first;
    // Base UI closes its list whether or not the event was prevented.
    const claimEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') event.preventDefault();
    };

    window.addEventListener('keydown', claimEscape, { capture: true });
    return () => window.removeEventListener('keydown', claimEscape, { capture: true });
  }, [isOpen]);
}
